import http from '@/plugins/http'
import EmploymentExternalCalendarConnections from '@/models/Synchronizations/EmploymentExternalCalendarConnections'
import {
  ADD_SHARED_MAILBOX,
  REMOVE_SHARED_MAILBOX,
} from '@/graphql/mutations/shared-mailbox'

export default class ExternalCalendars {
  static async updateCompanyCalendar(company, group, params) {
    await http.put(`companies/${company.id}/synchronizations/${group}`, params)
  }

  static deleteCalendar(company, calendar) {
    return http.delete(
      `companies/${company.id}/synchronizations/${calendar.group}?company=${company.id}`
    )
  }

  static reconnect(company, connection, redirectUrl) {
    return http.post(
      `external-calendar-connections/${connection.id}/reconnect`,
      {
        company_id: company.id,
        redirect_url: redirectUrl,
      }
    )
  }

  static async getSynchronizations(company) {
    const { data } = await http.get(
      `companies/${company.id}/synchronizations?company=${company.id}`
    )

    return data
  }

  static async getEmploymentExternalCalendarConnections(
    employmentKey,
    companyKey
  ) {
    const { data } = await http.get(
      `employments/${employmentKey}/external-calendar-connections?company=${companyKey}`
    )

    return new EmploymentExternalCalendarConnections(data)
  }

  static async create(companyId, params) {
    return http.post(`companies/${companyId}/synchronizations`, params)
  }

  static async deleteConnection(employment, company, connection) {
    return http.delete(
      `employments/${employment.id}/external-calendar-connections/${connection.id}?company=${company.id}`
    )
  }

  static async addSharedMailbox(apolloClient, companyId, connectionId, email) {
    return apolloClient.mutate({
      mutation: ADD_SHARED_MAILBOX,
      variables: {
        input: {
          company: companyId,
          connection: connectionId,
          email,
        },
      },
    })
  }

  static async removeSharedMailbox(apolloClient, companyId, sharedMailboxId) {
    return apolloClient.mutate({
      mutation: REMOVE_SHARED_MAILBOX,
      variables: {
        input: {
          company: companyId,
          sharedMailbox: sharedMailboxId,
        },
      },
    })
  }
}
